let ALWAYS_ON = ['Calendar', 'Comms', 'Tasks']

export function canBeClosed(type) {
  return !ALWAYS_ON.includes(type)
}
